import * as yup from 'yup'
import { ADDRESS_PATTERN, CITY_PATTERN, ZIP_PATTERN } from '@ally/aos-utils'
import {
  ADDRESS_VALIDATION_MESSAGES,
  CITY_VALIDATION_MESSAGES,
  STATE_VALIDATION_MESSAGES,
  ZIP_CODE_VALIDATION_MESSAGES,
} from './constants'
import { isPoBox } from './address'

export const baseValidationSchema = yup.object().shape({
  addressLine1: yup
    .string()
    .required(ADDRESS_VALIDATION_MESSAGES.validAddress)
    .matches(ADDRESS_PATTERN, ADDRESS_VALIDATION_MESSAGES.specialChar)
    .test(
      'isPoBox',
      ADDRESS_VALIDATION_MESSAGES.poBox,
      value => !isPoBox(value),
    ),
  addressLine2: yup
    .string()
    .matches(ADDRESS_PATTERN, ADDRESS_VALIDATION_MESSAGES.specialChar)
    .test('isPoBox', ADDRESS_VALIDATION_MESSAGES.poBox, value =>
      value ? !isPoBox(value) : true,
    ),
  city: yup
    .string()
    .required(CITY_VALIDATION_MESSAGES.validCity)
    .matches(CITY_PATTERN, CITY_VALIDATION_MESSAGES.specialChar),
  state: yup.string().required(STATE_VALIDATION_MESSAGES.validState),
  zipCode: yup
    .string()
    .required(ZIP_CODE_VALIDATION_MESSAGES.validZipCode)
    .matches(ZIP_PATTERN, ZIP_CODE_VALIDATION_MESSAGES.validZipCode),
})
